import { h } from '@stencil/core';
import { isMobile } from '../../../globals/utils';
export class SoftwareModal {
  constructor() {
    this.isOpen = false;
    this.headerLabel = undefined;
  }
  didModalClose() {
    this.didSoftwareModalClose.emit();
    this.isOpen = false;
  }
  getSize() {
    if (isMobile()) {
      return 'fill';
    }
    return 'xlarge';
  }
  render() {
    return (h("se-dialog", { open: this.isOpen, size: this.getSize(), "can-backdrop": true }, h("se-dialog-header", { "close-icon": "true", option: "indent" }, h("h2", { class: "dialog-header-title" }, this.headerLabel)), h("se-dialog-content", null, h("slot", null))));
  }
  static get is() { return "pes-software-modal"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["software-modal.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["software-modal.css"]
    };
  }
  static get properties() {
    return {
      "isOpen": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Is modal open or not"
        },
        "attribute": "is-open",
        "reflect": false,
        "defaultValue": "false"
      },
      "headerLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Modal header text"
        },
        "attribute": "header-label",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "didSoftwareModalClose",
        "name": "didSoftwareModalClose",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "didCloseDialog",
        "method": "didModalClose",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "backdrop",
        "method": "didModalClose",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
